<template>
  <div style="background: #f0f4f7;padding-top: 140px;">
<!--    <AboutBanner :content="banners.find(item=>item.id === 119).details"
                 :title="banners.find(item=>item.id === 119).title" :img="banners.find(item=>item.id === 103).photo_file"/>
  -->  <maps/>

    <AboutTitle title="شرایط اخذ نمایندگی" page-route="/sub/material/representation"/>
    <AboutCart
        v-for="(item,index) in representation.topics" :key="index"
        :title="item.title"
        :content="item.details" :img="item.photo_file"
    />

    <AboutTitle title="فرم اخذ نمایندگی" page-route="/sub/material/agencies-form"/>
    <AgenciesForm/>
  </div>
</template>

<script>
import Maps from "./Maps";
import AboutTitle from "../About/Components/AboutTitle";
import AboutCart from "../About/Components/AboutCart";
import {mapState} from "vuex";
import AgenciesForm from "./AgenciesForm/AgenciesForm";
import AboutBanner from "../About/Components/AboutBanner";

export default {
  data(){
    return {
      provinces: {
        Tehran:{
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `تهران`,
        },
        Alborz: {
          opacity: 1,
          bgColor: '#f00',
          tooltip : `البرز`,
        },
        Ardabil: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `اردبیل`,
        },
        AzerbaijanEast: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `آذربایجان شرقی`,
        },
        AzerbaijanWest: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `آذربایجان غربی`,
        },
        Bushehr: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `بوشهر`,
        },
        ChaharMahaalBakhtiari: { 
          opacity: 1,
          bgColor: '#f00',
          tooltip : `چهارمحال بختیاری`,
        },
        Fars: { 
          opacity: 1,
          bgColor: '#f00',
          tooltip : `فارس`,
        },
        Gilan: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `گیلان`,
        },
        Golestan: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `گلستان`,
        },
        Hamadan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `همدان`,
        },
        Hormozgan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `هرمزگان`,
        },
        Ilam: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `ایلام`,
        },
        Isfahan: { 
          opacity: 1,
          bgColor: '#408fbc',
          tooltip : `اصفهان`,
        },
        Kerman: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `کرمان`,
        },
        Kermanshah: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `کرمانشاه`,
        },
        KhorasanNorth: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `خراسان شمالی`,
        },
        KhorasanRazavi: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `خراسان رضوی`,
        },
        KhorasanSouth: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `خراسان جنوبی`,
        },
        Khuzestan: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `خوزستان`,
        },
        KohgiluyehBoyerAhmad: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `کهکیلویه بویراحمر`,
        },
        Kurdistan: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `کردستان`,
        },
        Lorestan: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `لرستان`,
        },
        Markazi: { 
          opacity: 1,
          bgColor: '#e61175',
          tooltip : `مرکزی`,
        },
        Mazandaran: { 
          opacity: 1,
          bgColor: '#e2041b',
          tooltip : `مازندران`,
        },
        Qazvin: { 
          opacity: 1,
          bgColor: '#003683',
          tooltip : `قزوین`,
        },
        Qom: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `قم`,
        },
        Semnan: { 
          opacity: 1,
          bgColor: '#039330',
          tooltip : `سمنان`,
        },
        SistanBaluchestan: { 
          opacity: 1,
          bgColor: '#80378b',
          tooltip : `سیستان و بلوچستان`,
        },
        Yazd: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `یزد`,
        },
        Zanjan: { 
          opacity: 1,
          bgColor: '#f49300',
          tooltip : `زنجان`,
        },
      },
    }
  },
  name: "operationNetwork",
  components: {AboutBanner, AgenciesForm, AboutCart, AboutTitle, Maps},
  created() {
    if (this.banners==null){
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    this.$store.dispatch('lightBlocksManagement/getRepresentation');
  },
  computed: {
    ...mapState({
      representation: state => state.lightBlocksManagement.representation,
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  },
  methods:{
    getGender(item) {
      if (this.localizeTitle(item) === 'جنسیت') {
        console.log(item.model.toString());
        if (item.model.toString() == 'زن') {
          this.showMilitaryService = false;
        } else {
          this.showMilitaryService = true;
        }
      }
    },
    localizeTitle(item){
      if(this.lang == "en"){
        return item.title_en;
      }else if(this.lang == "ar"){
        return item.title_ar;
      }else{
        return item.title_fa;
      }
    },
  }
}
</script>

